import { useState } from "react";
import apiMaestras from "../api/Maestras/api-maestras";
import { ActividadCronograma } from "../models/Maestras/maestras.model";

export const useGestionActividades = () => {
    const [cantidadPaginas, setCantidadPaginas] = useState(10);
    const cambiarCantidadPaginas = (e: any, value: any) => {
        setCantidadPaginas(value);
    };


    const [actividadesCronograma, setActividadesCronograma] = useState<ActividadCronograma[]>([]);
    const obtenerCronogramaActividades = async() => {
        try {
            const actividadesCronograma = await apiMaestras.obtenerActividadesCronograma();
            setActividadesCronograma(actividadesCronograma)
        } catch (error) {
            console.error(error);
        }
    }

    return {
        cantidadpaginas: cantidadPaginas,
        cambiarCantidadPaginas,
        obtenerCronogramaActividades,
        actividadesCronograma,
        setActividadesCronograma
    } 
}
